export default {"src":"/_next/static/media/step-two.057528a7.gif","height":976,"width":832};